/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import useTagManager from '../../hooks/use-tag-manager'

const PromoCallout = ({setColor, product, promotions, productPromotions, color, priceData}) => {
    const tagManager = useTagManager()
    const styles = useMultiStyleConfig('ProductView')
    useEffect(() => {
        if (setColor) {
            setColor(color || 'green.500')
        }
    }, [color])

    useEffect(() => {
        if (productPromotions?.length) {
            productPromotions.forEach((promo) => {
                if (promo?.name && promo?.c_type === 'PRODUCT') {
                    window.__dataLayerLoaded = true
                    tagManager.promoMessageImpression({
                        id: promo.id,
                        name: promo?.name,
                        price: priceData?.currentPrice,
                        creative: `PDP ${
                            promo.backgroundColor || promo.c_backgroundColor || 'green'
                        } badge`,
                        position: 'pdp'
                    })
                    window.__dataLayerLoaded = false
                }
            })
        }
    }, [product?.id, productPromotions?.length])

    return (
        <>
            {promotions?.map(
                (promotion, index) =>
                    promotion.name &&
                    promotion?.c_type === 'PRODUCT' && (
                        <Box
                            className="promo-box"
                            key={index}
                            {...styles.promotion}
                            data-id={promotion?.id}
                            backgroundColor={promotion?.c_backgroundColor || 'green.100'}
                        >
                            <Text color={promotion?.c_textColor || 'green.500'}>
                                {promotion.name}
                            </Text>
                        </Box>
                    )
            )}
        </>
    )
}

PromoCallout.propTypes = {
    product: PropTypes.object,
    promotions: PropTypes.any,
    productPromotions: PropTypes.any,
    color: PropTypes.any,
    priceData: PropTypes.any,
    setColor: PropTypes.func
}

export default PromoCallout
